// const shouldDisplay = (role, tabId) => {
//   console.log('role: ', role)
//   const byRole = checkByRole(role, tabId);
//   const byFeature = checkByFeature(role, tabId);

//   return byRole && byFeature;
// };

export const checkByRole = (role) => {
  const roleLower = role ? role.toLowerCase() : '';
  const permissions = {
    admin: [0, 1, 3, 19], //[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
    demo: [0, 1],
    caretaker: [0, 1],
    patient: [],
    technician: [],
    'security guard': [],
  };

  const rolePermission = permissions[roleLower]
    ? permissions[roleLower]
    : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
  return rolePermission;
};

// const checkByFeature = (role, tabId) => {
//   let shouldDisplay = true;
//   switch (tabId) {
//     case 7:
//       shouldDisplay = config.features.report.vitalSign;
//       break;
//     case 8:
//       shouldDisplay = config.features.report.garmin;
//       break;
//   }

//   return shouldDisplay;
// };
